// extracted by css-extract-rspack-plugin
export default {"container":"aAGtj9nq1fgngkpx"};